var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Table from "@/components/Table/Table";
import Thead from "@/components/Table/Thead";
import Tr from "@/components/Table/Tr";
import Th from "@/components/Table/Th";
import Tbody from "@/components/Table/Tbody";
import Td from "@/components/Table/Td";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { merchantState } from "@/views/Home/state";
import { useAPI } from "@/hooks/useAPI";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import PencilIcon from "../Icons/PencilIcon";
function drawStatus(status) {
    return {
        ACTIVE: (_jsx("span", { className: "bg-[#1BC5BD33] bg-opacity-20 text-[#1BC5BD] px-3 py-1 rounded-md", children: "ACTIVE" })),
        INACTIVE: (_jsx("span", { className: "bg-[#FFAE5033] bg-opacity-20 text-[#FFAE50] px-3 py-1 rounded-md", children: "INACTIVE" })),
    }[status];
}
export default function MerchantStoresTable(_a) {
    var _this = this;
    var type = _a.type;
    var hitAPI = useAPI();
    var merchant = useRecoilValue(merchantState);
    var _b = useState({
        data: [],
        meta: {
            current_page: 1,
            last_page: 1,
            per_page: 15,
            total: 0,
        },
    }), data = _b[0], setData = _b[1];
    var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!merchant)
                        return [2 /*return*/];
                    return [4 /*yield*/, hitAPI("/merchant/".concat(merchant.id, "/stores?type=").concat(type))];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (response.ok)
                        setData(data.data);
                    else
                        toast.error(data.message);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchData();
    }, []);
    return (_jsx(_Fragment, { children: _jsxs(Table, { children: [_jsx(Thead, { children: _jsxs(Tr, { children: [_jsx(Th, { children: "Name" }), _jsx(Th, { children: "Address" }), _jsx(Th, { children: "City" }), _jsx(Th, { children: "Status" }), _jsx(Th, { children: "Action" })] }) }), _jsx(Tbody, { children: data.data.length > 0 ? (data.data.map(function (store) {
                        return (_jsxs(Tr, { children: [_jsx(Td, { children: store.name }), _jsx(Td, { children: store.address }), _jsxs(Td, { children: [store.city, ", ", store.district] }), _jsx(Td, { children: drawStatus(store.status) }), _jsx(Td, { children: _jsx(Link, { to: "/merchant/settings/stores/".concat(store.id), children: _jsx(PencilIcon, {}) }) })] }, store.id));
                    })) : (_jsx(Td, { colSpan: 6, children: "No store for this category. Create one?" })) })] }) }));
}
